import { useQuery } from './query';
export function useTravelClass({
  dispatch,
  value,
  initValue,
  getTravelClassesApi,
  getTravelClasses,
  integrationSettings,
  prePopulation,
  meta,
  travelClassFilterv2 = false
}) {
  const getData = () => {
    return getTravelClasses(prePopulation, integrationSettings, meta)
      .then((data) => {
        return data;
      })
      .catch((err) => {
        throw err;
      });
  };
  let optionsApi = null;
  const options = useQuery({ getData, active: getTravelClassesApi }, [
    integrationSettings,
    meta,
    getTravelClasses
  ]);
  if (getTravelClassesApi) {
    optionsApi = { options: options.data };
    if (!options.isLoading && !options.data.some((d) => d.value === value[0])) {
      optionsApi = { ...optionsApi, defaultValue: 'ALL' };
    }
  }

  const onChange = (selectedClass) => {
    dispatch({ type: 'TRAVEL_CLASS_CHANGE', payload: [selectedClass.value] });
  };
  const onChangeV2 = (selectedClass) => {
    dispatch({ type: 'TRAVEL_CLASS_CHANGE_NO_TRACKING', payload: [selectedClass.value] });
  };

  return {
    value,
    defaultValue: Array.isArray(initValue) ? initValue[0] : initValue ? initValue : undefined,
    ...optionsApi,
    onChange: onChange,
    onChangeV2: onChangeV2,
    isChanged:
      Array.isArray(initValue) && Array.isArray(value)
        ? initValue.some((item, index) => item !== value[index])
        : initValue !== value
  };
}
